var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSignupCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.19234C3.77676 10.0662 4.3042 11.1855 5.09571 12.065C5.31738 12.3113 5.59614 12.6264 5.7602 12.9135C5.93033 13.2112 6.13531 13.4043 6.3838 13.1282C6.78521 12.6822 7.12194 12.1549 7.55433 11.7225C8.26578 11.0111 8.89106 10.1372 9.66537 9.47347C10.2534 8.96941 10.6069 8.30195 11.1426 7.76624C11.7079 7.20089 12.2289 6.54703 12.7118 5.9261C13.0186 5.53166 13.5227 4.71303 13.9488 4.5",
    stroke: "#DDDDE3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignupCheck);
export default __webpack_public_path__ + "static/media/icon-signup-check.2196df7c7254a73135fad1b674ea2f3f.svg";
export { ForwardRef as ReactComponent };